import { sub, add, isBefore, isToday, parse, format } from "date-fns";

import Router from "@lib/router/Router";

import type { TPickupTimeFrame } from "../types";

const toUnixTime = (time: string): number => parse(time, "HH:mm", new Date()).getTime();

const timeWithCutoff = (time, cutoff = 0) =>
  format(sub(parse(time, "HH:mm", new Date()), { minutes: cutoff }), "HH:mm");

const getLatestPickupToday = (timeFrames: TPickupTimeFrame[]): string | undefined => {
  const todaysTimeFrame = timeFrames.find(({ date }) => isToday(date));
  if (!todaysTimeFrame) {
    return undefined;
  }

  const isLithuaniaPage = Router.defaultLocale === "lt";

  const availableTimeFrom = [...(todaysTimeFrame.timeFrameFrom || [])]
    // Sort in case of wrong order of the results and reverse the original order
    // to search from latest time to earliest
    .sort((a, b) => toUnixTime(b) - toUnixTime(a))
    .find((time) => {
      const timeDate = parse(time, "HH:mm", new Date());
      const cutoff = (isLithuaniaPage && time === "15:00") ? 0 : (todaysTimeFrame.cutoff || 0);

      return !isBefore(timeDate, add(new Date(), { minutes: cutoff }));
    });

  if (availableTimeFrom) {
    const cutoff = (isLithuaniaPage && availableTimeFrom === "15:00") ? 0 : (todaysTimeFrame.cutoff || 0);
    return timeWithCutoff(availableTimeFrom, cutoff);
  }

  return availableTimeFrom;
};
export default getLatestPickupToday;
